import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, PopoverController, ToastController } from '@ionic/angular';
import { FotosService } from 'src/app/servicios/fotos/fotos.service';
import * as fileUpload from 'fuctbase64';
import { ImagenesService } from 'src/app/servicios/imagenes.service';
import { NgxImageCompressService } from 'ngx-image-compress-legacy';
import { CONFIGURATIONS } from 'src/constant/constantes';


@Component({
  selector: 'app-fotosdentro',
  templateUrl: './fotosdentro.component.html',
  styleUrls: ['./fotosdentro.component.scss'],
})

export class FotosdentroComponent implements OnInit {

  sliderOpts= {
    zoom:{maxRatio: 2}
  };
  constructor(public alertCtrl: AlertController, public fotosService: FotosService, 
    private toastController: ToastController, public loadingController: LoadingController,
    public poper: PopoverController, public imagenesService: ImagenesService,
    private imageCompress: NgxImageCompressService) {
      this.fotoDentro64 = this.imagenesService.imagenFotoDentro();
    this.fotoDentro = fotosService.fotosDentro;
    this.calcularPrecioFotos();
   }

  ngOnInit() {}
  precioTotal=0;
  configuracion = CONFIGURATIONS;

  fotoDentro64;
  calcularPrecioFotos(){
    let cantidad = this.fotoDentro.length;
    this.precioTotal = this.configuracion.precioPorFoto * cantidad;
  }

  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  changeListener($event: any): void {
    fileUpload($event)
      .then((data) => {
        this.compressFile(data, data.name)
      })
  }

  imgResultAfterCompress: string;
  async compressFile(image, fileName) {
    const loading = await this.loadingController.create({
      message: "ʕ•́ᴥ•̀ʔっ"
    });
    await loading.present();
    var orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    this.imageCompress.compressFile("data:image/jpeg;base64," + image.base64, orientation, 35, 35).then(
      (result: any) => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024)
        this.fotosService.agregarFotoDentro(this.imgResultAfterCompress);
        this.calcularPrecioFotos();
      }).finally(function(){
        loading.dismiss();
      });;
  }
   async Alerta(mensaje, submensaje) {   
    let ok = "Ok";
    const alert = await this.alertCtrl.create({
      header: mensaje,    
      subHeader: submensaje,
      buttons: [         
         { 
          text: "Entiendo",
          handler: data => console.log("si"),
          role:  '',           
         },                   
    ]        
    });            
    await alert.present();     
  }

   fotoDentro = [];

   frase(event, i){
    let Mifrase = event.detail.value;
    this.fotosService.fotosDentro[i].frase = Mifrase;
    
    }
  
    deleteImage2(i){
      this.fotoDentro.splice(i, 1);
      this.calcularPrecioFotos();
    }
  
    async deleteImage(i) {
      const alert = await this.alertCtrl.create({
        header: "Eliminar foto",
        subHeader: "¿Seguro de eliminar esta fotografía?",
        buttons: [
          {
            text: "Si",
            handler: data => this.deleteImage2(i),
            role: '',
          },
          {
            text: "No",
            handler: data => console.log("ok"),
            role: '',
          },
        ]
      });
      await alert.present();
    }

    async aceptarPopOver(){
      this.poper.dismiss({      
      });
    
    }

    async mostrarToast(color: 'success' | 'danger' | 'warning') {
      const toast = await this.toastController.create({
        message: "¡Bien!, Foto Agregada",
        position: 'bottom',
        duration: 2000,
        color: color
      });
      toast.present();
    }  
    
    async cerarPopOver(){  
      this.poper.dismiss(); 
    }
}
